// targets keys: heading, content, image
const targets = getTargets();

function getTargets() {
	const targets = {
		container: document.querySelector(".content"),
		heading: document.querySelector(".content h1"),
		content: document.querySelector(".content .body"),
		image: document.querySelector(".content .product"),
		nav: document.querySelector(".nav .interface")
	};
	return targets;
}

async function getContent() {
	const response = await fetch('./content/data.json');
	const json = await response.json();
	assignClick(json);
	preloadImages(json);
}

function preloadImages(json) {
	for (brand in json) {
		let img = document.createElement("img");
		img.src = json[brand].image;
	}
}

function assignClick(json) {
	for (item in json) {
		// svg hit area to be clicked
		const shooter = targets.nav.querySelector("#" + item);
		if (shooter !== null) {
			// when clicked pass the content for that hit area
			const content = json[item];
			shooter.onclick = () => changeContent(content, shooter);
		}
	}
}

function changeContent(content, shooter) {
	// classing unclassing of the current active
	resetNavClasses();
	shooter.classList.add("hover");
	targets.container.classList.add("active");
	// change the content
	targets.heading.innerHTML = content.heading;
	targets.content.innerHTML = content.content;
	targets.content.append(backToTop());
	targets.image.src = content.image;
	// scroll animate
	targets.container.scrollIntoView();
}

function resetNavClasses() {
	const active = targets.nav.querySelectorAll(".hover");
	active.forEach(ele => ele.classList.remove("hover"));
}

function backToTop() {
	// back to top base element
	const container = document.createElement("div");
	container.classList.add("btt");
	// the visible link
	const link = document.createElement("a");
	link.innerHTML = "[ <strong>Back to top</strong> ]";
	link.onclick = () => targets.nav.scrollIntoView();
	// combine and return
	container.append(link);
	return container;
}

export function init() {
	getContent();
}
